import Close from "Components/close";
import withPopover from "Components/withPopover";
import classNames from "classnames";
import React from "react";
import ColorIndicator from "./colorIndicator";
const ColorToggler = withPopover((props) => (React.createElement("div", { id: props.id, className: classNames("text-editor-wrapper-imitation box-with-text-editor-paddings w-100 grid-cols-1fr-auto v-center-items", !props.disabled ? "clickable" : "no-pointer-events", !props.color && "text-muted", props.className) },
    React.createElement("div", { className: "grid-cols-auto-1fr v-center-items overflow-hidden" },
        React.createElement(ColorIndicator, { size: 16, bgColor: props.color }),
        React.createElement("div", { className: "ml-0_5 text-overflow-ellipsis" }, props.color || props.placeholder)),
    React.createElement(Close, { className: classNames("text-gray-500", (props.disabled || !props.hasClearBtn) && "invisible"), fontSize: 14, onClick: props.onClear }))));
export default ColorToggler;
